var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "archive_FILL0_wght400_GRAD0_opsz48 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(-1039.000000, -404.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1019.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive_FILL0_wght400_GRAD0_opsz48-Copy",
    transform: "translate(20.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8892B0",
    d: "M1.16666667,14 C0.855555556,14 0.583333333,13.8833333 0.35,13.65 C0.116666667,13.4166667 0,13.1444444 0,12.8333333 L0,2.66388889 C0,2.46944444 0.0194444444,2.30416667 0.0583333333,2.16805556 C0.0972222222,2.03194444 0.168518519,1.90555556 0.272222222,1.78888889 L1.36111111,0.311111111 C1.46481481,0.194444444 1.58472222,0.113425926 1.72083333,0.0680555556 C1.85694444,0.0226851852 2.01574074,0 2.19722222,0 L11.8027778,0 C11.9842593,0 12.1398148,0.0226851852 12.2694444,0.0680555556 C12.3990741,0.113425926 12.5157407,0.194444444 12.6194444,0.311111111 L13.7277778,1.78888889 C13.8314815,1.90555556 13.9027778,2.03194444 13.9416667,2.16805556 C13.9805556,2.30416667 14,2.46944444 14,2.66388889 L14,12.8333333 C14,13.1444444 13.8833333,13.4166667 13.65,13.65 C13.4166667,13.8833333 13.1444444,14 12.8333333,14 L1.16666667,14 Z M1.49722222,2.06111111 L12.4833333,2.06111111 L11.7833333,1.16666667 L2.19722222,1.16666667 L1.49722222,2.06111111 Z M1.16666667,3.22777778 L1.16666667,12.8333333 L12.8333333,12.8333333 L12.8333333,3.22777778 L1.16666667,3.22777778 Z M7,11.0833333 L10.0333333,8.05 L9.25555556,7.27222222 L7.58333333,8.94444444 L7.58333333,5.03611111 L6.41666667,5.03611111 L6.41666667,8.94444444 L4.74444444,7.27222222 L3.96666667,8.05 L7,11.0833333 Z M1.16666667,12.8333333 L12.8333333,12.8333333 L1.16666667,12.8333333 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.32f9ad9c3be925d6b04fe79c1f74e415.svg";
export { ForwardRef as ReactComponent };